import { render, staticRenderFns } from "./editHelpDocsModal.vue?vue&type=template&id=74c66d00&scoped=true"
import script from "./editHelpDocsModal.vue?vue&type=script&lang=js"
export * from "./editHelpDocsModal.vue?vue&type=script&lang=js"
import style0 from "./editHelpDocsModal.vue?vue&type=style&index=0&id=74c66d00&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c66d00",
  null
  
)

export default component.exports